import React from 'react';
import {
  Step,
  StepNumber,
  StepContent,
  StepContentTitle,
  StepContentText,
  Image
} from 'products/nomad_insurance/views/Profile/ClaimsOld/styled';
import stepTwoImage from 'products/nomad_insurance/assets/img/claims/step-two-copy.svg';

const StepTwo = () => {
  return (
    <Step>
      <StepNumber>
        <span>2</span>
      </StepNumber>
      <StepContent>
        <Image>
          <img src={stepTwoImage} alt="Illustration of confirmation email" />
        </Image>
        <StepContentTitle>Receive the confirmation</StepContentTitle>
        <StepContentText>
          You will receive a confirmation email shortly after you submit your claim.
        </StepContentText>
      </StepContent>
    </Step>
  );
};

export default StepTwo;
